export const textMap = {
    red: "text-red-300",
    orange: "text-orange-300",
    amber: "text-amber-300",
    yellow: "text-yellow-300",
    lime: "text-lime-300",
    green: "text-green-300",
    emerald: "text-emerald-300",
    teal: "text-teal-300",
    cyan: "text-cyan-300",
    sky: "text-sky-300",
    blue: "text-blue-300",
    indigo: "text-indigo-300",
    violet: "text-violet-300",
    purple: "text-purple-300",
    pink: "text-pink-300",
    rose: "text-rose-300",
    gold: "text-[#c69b58cc]",
};

export const neonMap = {
    red: "neon-red",
    orange: "neon-orange",
    amber: "neon-amber",
    yellow: "neon-yellow",
    lime: "neon-lime",
    green: "neon-green",
    emerald: "neon-emerald",
    teal: "neon-teal",
    cyan: "neon-cyan",
    sky: "neon-sky",
    blue: "neon-blue",
    indigo: "neon-indigo",
    violet: "neon-violet",
    purple: "neon-purple",
    pink: "neon-pink",
    rose: "neon-rose",
    gold: "neon-gold",
};

export const borderMap = {
    red: "border border-red-500/50",
    orange: "border border-orange-500/50",
    amber: "border border-amber-500/50",
    yellow: "border border-yellow-500/50",
    lime: "border border-lime-500/50",
    green: "border border-green-500/50",
    emerald: "border border-emerald-500/50",
    teal: "border border-teal-500/50",
    cyan: "border border-cyan-500/50",
    sky: "border border-sky-500/50",
    blue: "border border-blue-500/50",
    indigo: "border border-indigo-500/50",
    violet: "border border-violet-500/50",
    purple: "border border-purple-500/50",
    pink: "border border-pink-500/50",
    rose: "border border-rose-500/50",
    gold: "border border-[rgba(var(--primary-rgb),0.5)]"
};

export const bgMap = {
    red: "bg-red-500",
    orange: "bg-orange-500",
    amber: "bg-amber-500",
    yellow: "bg-yellow-500",
    lime: "bg-lime-500",
    green: "bg-green-500",
    emerald: "bg-emerald-500",
    teal: "bg-teal-500",
    cyan: "bg-cyan-500",
    sky: "bg-sky-500",
    blue: "bg-blue-500",
    indigo: "bg-indigo-500",
    violet: "bg-violet-500",
    purple: "bg-purple-500",
    pink: "bg-pink-500",
    rose: "bg-rose-500",
    gold: "bg-[rgba(var(--primary-rgb),0.5)]"
};

export const lightBgMap = {
    red: "bg-red-300",
    orange: "bg-orange-300",
    amber: "bg-amber-300",
    yellow: "bg-yellow-300",
    lime: "bg-lime-300",
    green: "bg-green-300",
    emerald: "bg-emerald-300",
    teal: "bg-teal-300",
    cyan: "bg-cyan-300",
    sky: "bg-sky-300",
    blue: "bg-blue-300",
    indigo: "bg-indigo-300",
    violet: "bg-violet-300",
    purple: "bg-purple-300",
    pink: "bg-pink-300",
    rose: "bg-rose-300",
    gold: "bg-[rgba(var(--primary-rgb),0.1)]"
};

export const vectorMap = {
    red: "brightness-[0] invert-[1]",
    orange: "brightness-[0.6] invert-[0.2]",
    amber: "brightness-[0.6] invert-[0.2]",
    yellow: "brightness-[0] invert-[1]",
    lime: "brightness-[0.5] invert-[0.5]",
    green: "brightness-[0.5] invert-[0.5]",
    emerald: "brightness-[0.5] invert-[0.5]",
    teal: "brightness-[0.5] invert-[0.5]",
    cyan: "brightness-[0] invert-[1]",
    sky: "brightness-[0.8] invert-[1]",
    blue: "brightness-[0.8] invert-[1]",
    indigo: "brightness-[0] invert-[1]",
    violet: "brightness-[0] invert-[1]",
    purple: "brightness-[0] invert-[1]",
    pink: "brightness-[0] invert-[1]",
    rose: "brightness-[0] invert-[1]",
    gold: ""
};